import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Fragment } from 'react';
import { ExpandableSection } from '../../components/expandableSection';
import { FRIENDS_PANEL_DIVIDER_COLOR } from '../../styles/colors';
import { ACTIVE_CONTACT_EXPANDABLE_SECTION_TYPES, ALL_ACTIVE_CONTACT_TYPES } from '../../types/contactTypes';
import { PanelItem } from '../panelItem';
import { PanelItemDivider } from '../panelItemDivider';
import { ActiveContactPanelItem } from './activeContactPanelItem';
import { FriendsPanelAllFriendsContainer } from './friendsPanelAllFriendsContainer';
export const FriendsPanelContents = ({ activeContacts }) => {
    const hasActiveContacts = Object.values(activeContacts).some((activeContactsInType) => !!activeContactsInType?.length);
    const activeContactsContent = !hasActiveContacts ? (_jsx(PanelItem, { children: "No active friends or contacts." })) : (_jsx(_Fragment, { children: ALL_ACTIVE_CONTACT_TYPES.map((type, i) => {
            const activeContactsInType = activeContacts[type];
            if (!activeContactsInType || !activeContactsInType.length) {
                return null;
            }
            return (_jsx(ExpandableSection, { expandableSectionType: ACTIVE_CONTACT_EXPANDABLE_SECTION_TYPES[type], colorType: 'friends', children: activeContactsInType.map((activeContact, j) => (_jsxs(Fragment, { children: [j > 0 && _jsx(PanelItemDivider, { color: FRIENDS_PANEL_DIVIDER_COLOR, thicknessPx: 2 }), _jsx(ActiveContactPanelItem, { activeContact: activeContact })] }, j))) }, i));
        }) }));
    return (_jsxs(_Fragment, { children: [activeContactsContent, _jsx(FriendsPanelAllFriendsContainer, { activeContacts: activeContacts })] }));
};
